<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div>
    <div class="action-key-container">
      <label class="tb-label hot-keys">Hot keys<br>
        <span class="hot-keys-desc">Trigger hotkey by pressing buttons or use keyboard shortcuts as shown.</span>
      </label>

      <div class="action-keys">
        <actionKey
          v-for="(action, index) in actions"
          :key="index"
          :action="action"
          :production_context="production_context"
          :data-test="`graphics-editor-timer-${action.hotkey.toLowerCase()}`"
        />
      </div>
    </div>

    <label v-if="element.counterFormat == 'Time'">Duration</label>

    <div class="timer-preview-group" v-if="element.counterFormat == 'Time'">
      <div class="timer-preview-select">
        <div class="timer-select">
          <select
            class="tb-select"
            v-model="element.hourPreview"
            data-entity="producer-editor-selectHourPreview"
            data-test="graphics-editor-timer-hourDropdown"
            @change="setHourPreview($event)"
          >
            <option
              v-for="hour in hoursList"
              :key="hour"
            >
              {{ hour }}
            </option>
          </select>
        </div>

        <label class="sidebar-input-sub-label">H</label>
      </div>

      <div class="timer-preview-select">
        <div class="timer-select">
          <select
            class="tb-select"
            v-model="element.minutePreview"
            data-entity="producer-editor-selectMinutePreview"
            data-test="graphics-editor-timer-minuteDropdown"
            @change="setMinutePreview($event)"
          >
            <option
              v-for="minute in minutesList"
              :key="minute"
            >
              {{ minute }}
            </option>
          </select>
        </div>

        <label class="sidebar-input-sub-label">M</label>
      </div>

      <div class="timer-preview-select">
        <div class="timer-select">
          <select
            class="tb-select"
            v-model="element.secondPreview"
            data-entity="producer-editor-selectSecondPreview"
            data-test="graphics-editor-timer-secondDropdown"
            @change="setSecondPreview($event)"
          >
            <option
              v-for="second in secondsList"
              :key="second"
            >
              {{ second }}
            </option>
          </select>
        </div>

        <label class="sidebar-input-sub-label">S</label>
      </div>
    </div>

    <div v-if="element.counterFormat == 'Date & Time'" class='datepicker'>
      <date-picker
        v-model="element.dateTime"
        type="datetime"
        time-title-format="MM/DD/YYYY hh:mm A"
        format="MM/DD/YYYY hh:mm A"
        value-type="format"
        :use12h="true"
        :default-value="element.dateTime || new Date()"
        :disabled-date="disabledDate"
        :disabled-time="disabledTime"
        placeholder="Select date and time"
        data-entity="producer-editor-dateTimePicker"
        data-test="graphics-editor-timer-picker"
        @change="setDateTime($event)"
      />
    </div>
  </div>
</template>

<script>
import datePicker from 'vue2-datepicker';
import dayjs from 'dayjs';

import actionKey from '../../../../panel-editor/hotkeys/ActionKey.vue';

export default {
  props: ['element', 'graphic_fields', 'production_context'],

  components: {
    datePicker,
    actionKey,
  },

  data() {
    return {
      hoursList: [],
      minutesList: [],
      secondsList: [],
      hourCutoffPreview: 0,
      minuteCutoffPreview: 0,
      secondCutoffPreview: 0,
      actions: [
        {
          hotkey: 'S',
          display: 'Start',
          description: 'Use this hotkey to start the timer',
          value: 'start',
          type: 'timer widget',
          elementId: this.element.id,
        },
        {
          hotkey: 'P',
          display: 'Pause',
          description: 'Use this hotkey to pause the timer',
          value: 'pause',
          type: 'timer widget',
          elementId: this.element.id,
        },
        {
          hotkey: 'R',
          display: 'Reset',
          description: 'Use this hotkey to reset the timer',
          value: 'reset',
          type: 'timer widget',
          elementId: this.element.id,
        },
      ],
    };
  },

  computed: {
    playBtn() {
      const { play, timerType } = this.element;

      if (play) {
        return timerType === 'Stopwatch' ? 'Stop' : 'Pause';
      }

      return timerType === 'Stopwatch' ? 'Start' : 'Play';
    },
  },

  mounted() {
    // create values for select menus
    for (let i = 0; i < 60; i += 1) {
      if (i < 24) this.hoursList.push(i);
      this.minutesList.push(i);
      this.secondsList.push(i);
    }

    // reset element id if we select a new layer while the layer settings panel is already open
    // vue has poor reactivity support for values in arrays
    this.$watch(() => this.element, () => {
      this.actions.forEach((action) => {
        action.elementId = this.element.id; // eslint-disable-line no-param-reassign
      });
    });
  },

  methods: {
    setHourPreview(event) {
      return this.$emit('value', {
        value: parseInt(event.target.value, 10),
        field: 'hourPreview',
      });
    },

    setMinutePreview(event) {
      return this.$emit('value', {
        value: parseInt(event.target.value, 10),
        field: 'minutePreview',
      });
    },

    setSecondPreview(event) {
      return this.$emit('value', {
        value: parseInt(event.target.value, 10),
        field: 'secondPreview',
      });
    },

    setDateTime(value) {
      return this.$emit('value', {
        value,
        field: 'dateTime',
      });
    },

    /**
    * Returns true if date should be disabled
    */
    disabledDate(date) {
      if (this.element.timerType === 'Countdown') {
        return dayjs(date).isBefore(dayjs().hour(0).minute(0).second(0)
          .format());
      }

      return dayjs(date).isAfter(dayjs().hour(0).minute(0).second(0)
        .format());
    },

    disabledTime(date) {
      if (this.element.timerType === 'Countdown') {
        return dayjs(date).isBefore();
      }

      return dayjs(date).isAfter();
    },
  },
};
</script>
